import React from 'react';
import CardActions from "../../../components/CardActions";
import {TransferenciaTercerosChequeosComplianceForm} from "./TransferenciaTercerosChequeosComplianceForm";

interface SeccionTransferenciaTercerosChequeosComplianceProps {
  idOperacion: number,
  expandir?: boolean,
  permiteEditar?: boolean,
}

export const SeccionTransferenciaTercerosChequeosCompliance = ({
                                                                 idOperacion,
                                                                 expandir,
                                                                 permiteEditar
                                                               }: SeccionTransferenciaTercerosChequeosComplianceProps) => {


  return (
    <CardActions title={'Chequeos Compliance'} icon='mdi:shield-check-outline' colapsable collapsed={expandir}>
      <TransferenciaTercerosChequeosComplianceForm
        permiteEditar={permiteEditar}
        idOperacion={idOperacion}
      />
    </CardActions>
  );
}


